<template>
    <div v-if="permission && permission.version === '5'">
        <div class="row page-heading mx-0">
            <div class="col-8 input module_heading" role="heading" aria-level="1">
                <span class="module_icon fa fa-groupbox" style="color: #157099;"></span>
                <span class="module_type_name">Group Management</span>
            </div>
            <div class="col-4 submit btn-container text-right">
                <button type="button" class="btn btn-primary" @click.prevent="create" aria-label="create" :disabled="permission.systemPermission.readOnly">create</button>
            </div>
        </div>

        <div class="folder-management-section group-list-section" v-if="isDataSetupFromServer">
            <div class="page_subheading">
              <div class="toolbar-right ui-list-toolbar">
                <select v-model="size" aria-label="page size" class="page_size">
                  <option v-for="option in pageOptions" v-bind:value="option">
                    {{ option }}
                  </option>
                </select>
                <div class="btn_container pagination_sty3">
                  <b-pagination
                    align="center"
                    :total-rows="totalRows"
                    :per-page="size"
                    v-model="pageNumber"
                    :limit="1"
                    :hide-goto-end-buttons="true"
                    :label-prev="$t('previousPage')"
                    :label-next="$t('nextPage')">
                    <template #prev-text>
                      <span class="ic2_arr_pre3" aria-hidden="true"></span>
                    </template>
                    <template #next-text>
                      <span class="ic2_arr_next3" aria-hidden="true"></span>
                    </template>
                  </b-pagination>
                </div>
                <div class="search-box-container">
                  <input type="text" class="input-search" v-model="filter" placeholder="search by group title" aria-label="search by group title">
                  <button type="button" class="btn btn_srh" aria-label="search groups">
                    <span class="ic_srh ic_search" aria-hidden="true"></span>
                  </button>
                </div>
              </div>
            </div>

            <b-container fluid>
                <b-row class="group-list-table">
                    <b-table bordered :isRowHeader="true" :head-variant="'light'" :items="groups"  :fields="fields"
                        :current-page="pageNumber" :per-page="size" :filter="filter" @filtered="onFiltered" class="group-management-table">

                        <template slot="title" slot-scope="row">
                            {{row.value}}
                        </template>
                        <template slot="url" slot-scope="row">
                            {{row.value}}
                        </template>
                        <template slot="actions" slot-scope="row">
                            <template v-if="permission.systemPermission.readOnly">
                                <span class="action-link icon-pencil mr-2" @click="editGroup(row.item)" aria-label="edit" tabindex="0" style="pointer-events: none; color: #ccc;"></span>
                                <span class="action-link icon-bin" @click="showDeleteGroupConfirmBox(row.item)" aria-label="delete" tabindex="0" style="pointer-events: none; color: #ccc;"></span>
                            </template>
                            <template v-else>
                                <span class="action-link icon-pencil mr-2" @click="editGroup(row.item)" aria-label="edit" tabindex="0"></span>
                                <span class="action-link icon-bin" @click="showDeleteGroupConfirmBox(row.item)" aria-label="delete" tabindex="0"></span>
                            </template>
                        </template>
                    </b-table>

                    <template v-if="shouldShowNoResultFound">
                        <span class="no-result">No Results Found</span>
                    </template>
                </b-row>

            </b-container>
        </div>

        <div class="modal_container modal_alart">
            <b-modal class="" ref="deleteGroupModal" :title="'Please Confirm!'" :header-bg-variant="'folder-delete-modal'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                <div>
                    <span>{{ groupDeleteMessage }}</span>
                </div>
              <div slot="modal-header" class="header-section">
                <div class="ic ic-hd"></div>
                <div class="head_txt">Please Confirm!</div>
                <button type="button" class="btn_close" @click="hideDeleteConfirmBox" aria-label="close">
                  <span class="ic-close"></span>
                </button>
              </div>
              <div slot="modal-footer" class="w-100">
                  <b-button @click="deleteGroupAndHideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="yes"> yes </b-button>
                  <b-button @click="hideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="no"> no </b-button>
              </div>
            </b-modal>
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import '../../../assets/module/css/tool/tool.min.css'

  export default {
    name: 'groupList',
    data () {
      return {
        groups: [],
        fields: [
          {key: 'name', label: 'Group Title', class: 'first-column'},
          {key: 'type', label: 'Configure Type', class: 'second-column'},
          {key: 'launchURL', label: 'Launch URL', class: 'third-column'},
          {key: 'actions', label: 'Actions', class: 'fourth-column text-center'}
        ],
        totalRows: 0,
        groupToDelete: '',
        groupDeleteMessage: '',
        isDataSetupFromServer: false,
        pageNumber: 1,
        size: 10,
        pageOptions: [ 10, 50, 100 ],
        filter: '',
        shouldShowNoResultFound: false
      }
    },

    async mounted () {
      await this.loadPermission()
      await this.searchForGroups()
    },

    methods: {
      ...mapActions([
        'loadPermission',
        'deleteSeletedGroup',
        'loadAllGroupsForInstitution',
        'searchGroups'
      ]),

      async searchForGroups () {
        let res = await this.searchGroups({page: this.pageNumber, count: this.size})
        if (!res) {
          return this.notifyFailure('Unable to find institution groups')
        }
        this.groups = res.content
        this.isGroupsLoded = true
        this.firstPage = res.firstPage
        this.lastPage = res.lastPage
        this.number = res.number
        this.totalPages = res.totalPages
        this.numberOfElements = res.numberOfElements
      },

      create () {
        return this.$router.push({name: 'groupDetail'})
      },

      editGroup (group) {
        return this.$router.push({name: 'groupDetail', params: {uuid: group.uuid}})
      },

      showDeleteGroupConfirmBox (group) {
        this.groupToDelete = group
        this.groupDeleteMessage = 'Are you sure you want delete "' + group.name + '".'
        this.$refs.deleteGroupModal.show()
      },

      hideDeleteConfirmBox () {
        this.$refs.deleteGroupModal.hide()
      },

      deleteGroupAndHideDeleteConfirmBox () {
        this.hideDeleteConfirmBox()
        this.$refs.loadingModal.show()
        let uuids = [this.groupToDelete.uuid]
        this.deleteSeletedGroup(uuids).then(res => {
          setTimeout(() => {
            this.loadGroupsForInstitution()
            this.$refs.loadingModal.hide()
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Group "' + this.groupToDelete.name + '" deleted successfully.'
            })
          }, 1000)
        })
      },

      onFiltered (filteredItems) {
        this.totalRows = filteredItems.length
        this.pageNumber = 1
        if (filteredItems.length === 0) {
          this.shouldShowNoResultFound = true
        } else {
          this.shouldShowNoResultFound = false
        }
      },

      showLoader () {
        return this.$refs.loadingModal.show()
      },

      hideLoader () {
        return this.$refs.loadingModal.hide()
      }
    },

    computed: {
      ...mapState({
        'permission': state => state.user.permission
      })
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/group/components/GroupList.vue